import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Configurator} from '@spartacus/product-configurator/rulebased';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {RefQuoteIdService} from './ref-quote-id.service';

const ADD_TO_CART_URL_REGEX = /\/users\/[^/]+\/carts\/[^/]+\/entries\/ccpconfigurator(?:[/?#]|$)/;

/**
 * Injects the refQuoteId from sessionStorage into CCP configurator add-to-cart requests.
 * Complements the direct flow (DcpCartDecoratorService) which already handles refQuoteId.
 */
@Injectable()
export class RefQuoteIdConfiguratorInterceptor implements HttpInterceptor {
  constructor(private refQuoteIdService: RefQuoteIdService) {}

  intercept(request: HttpRequest<Configurator.AddToCartParameters>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.isAddToCartCall(request)) {
      return next.handle(request);
    }

    const refQuoteId = this.refQuoteIdService.getRefQuoteId();
    if (!refQuoteId) {
      return next.handle(request);
    }

    const body = request.body;
    if (!body) {
      return next.handle(request);
    }

    const data = [
      ...(body.data ?? []).filter(({type}) => type !== 'refQuoteId'),
      {type: 'refQuoteId', value: refQuoteId},
    ];
    const enrichedRequest = request.clone({body: {...body, data}});

    return next.handle(enrichedRequest).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          this.refQuoteIdService.clearRefQuoteId();
        }
      }),
    );
  }

  private isAddToCartCall(request: HttpRequest<unknown>): boolean {
    return request.method === 'POST' && ADD_TO_CART_URL_REGEX.test(request.url);
  }
}
